import './lib/i18n';

import '@connected/ui/globals.css';
import 'flag-icons/css/flag-icons.min.css';

import '@/assets/styles/leaflet.css';
import '@/assets/styles/index.css';

import { LoggerContext } from '@connected/api-client/hooks/use-logger';
import { ThemeProvider } from '@connected/ui/providers/theme';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { logger } from './lib/logger';
import { queryClient } from './lib/query-client';
import { Providers } from './providers';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <LoggerContext value={{ logger }}>
            <QueryClientProvider client={queryClient}>
                <ThemeProvider>
                    <Providers />
                </ThemeProvider>
            </QueryClientProvider>
        </LoggerContext>
    </StrictMode>,
);
